(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="QhaRecommendations-"]').forEach((section) => {
    const track = section.querySelector('[data-recommendation-track]');
    const cards = [...section.querySelectorAll('[data-recommendation-card]')];
    const dots = [...section.querySelectorAll('[data-recommendation-dot]')];
    if (!track || cards.length < 2) return;

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      cards.forEach((card, cardIndex) => {
        if (cardIndex !== index) {
          card.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(cards.indexOf(entry.target));
      });
    }, { root: track, threshold: .7 });

    cards.forEach((card) => observer.observe(card));
  });

  } catch(e) { console.error(e); }
})();
})();
